// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/menu_feedback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/menu_feedback_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/menu_collect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/menu_collect_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/menu_setting.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../statics/menu_setting_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__-sKqk {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 20px 0 0;
    font-size: 25px;
    color: #888;
}

.Header_left__BE6sc {
    width: 300px;
    height: 100%;
    padding-left: 18px;
}

.Header_right__FX3Fx {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.Header_search_box__tumD9 {
    position: relative;
    width: 200px;
    height: 40px;
    margin-right: 20px;
}

.Header_search__DioNw {
    width: 100%;
    height: 100%;
    padding: 5px 5px 5px 30px;
    border: 1px solid #c1c1c1;
    border-radius: 6px;
    font-size: 14px;
}

.Header_search_icon__VLuIX {
    position: absolute;
    top: 15px;
    left: 10px;
    width: 11px;
    height: 12px;
}

.Header_search_box_mask__DQlyD {
    position: absolute;
    top: 6px;
    left: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    z-index: -1;
}

.Header_img_box__R7koX {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
}

/* .img_box:hover {
    background-color: #ccc;
} */

.Header_img__i4fim {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}

.Header_feedback_img__y6ZQd {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Header_feedback_img__y6ZQd:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.Header_collect_img__USR\\+2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.Header_collect_img__USR\\+2:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.Header_setting_img__Gikae {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.Header_setting_img__Gikae:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@keyframes Header_fadeIn__A9dyx {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
}

.Header_fade_in__x23EN {
    animation-name: Header_fadeIn__A9dyx;
    /* 动画持续时间为0.5秒 */
    animation-duration: 0.5s;
    /* 动画完成后保持最终状态 */
    animation-fill-mode: forwards;
}

.Header_back_img_box__TQoio {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #f2f2f2;
    border: 1px solid #CBD1D8;
    border-radius: 6px;
    cursor: pointer;
}

.Header_back_img__QD0j4 {
    width: 16px;
    height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/collect/components/Header/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,yDAA8D;AAClE;;AAEA;IACI,yDAAqE;AACzE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAoE;AACxE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAoE;AACxE;;AAEA;IACI;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;AACJ;;AAEA;IACI,oCAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 13px 20px 0 0;\n    font-size: 25px;\n    color: #888;\n}\n\n.left {\n    width: 300px;\n    height: 100%;\n    padding-left: 18px;\n}\n\n.right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.search_box {\n    position: relative;\n    width: 200px;\n    height: 40px;\n    margin-right: 20px;\n}\n\n.search {\n    width: 100%;\n    height: 100%;\n    padding: 5px 5px 5px 30px;\n    border: 1px solid #c1c1c1;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.search_icon {\n    position: absolute;\n    top: 15px;\n    left: 10px;\n    width: 11px;\n    height: 12px;\n}\n\n.search_box_mask {\n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: calc(100% - 12px);\n    height: calc(100% - 12px);\n    z-index: -1;\n}\n\n.img_box {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n}\n\n/* .img_box:hover {\n    background-color: #ccc;\n} */\n\n.img {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.feedback_img {\n    background-image: url('../../../../statics/menu_feedback.png');\n}\n\n.feedback_img:hover {\n    background-image: url('../../../../statics/menu_feedback_active.png');\n}\n\n.collect_img {\n    background-image: url('../../../../statics/menu_collect.png');\n}\n\n.collect_img:hover {\n    background-image: url('../../../../statics/menu_collect_active.png');\n}\n\n.setting_img {\n    background-image: url('../../../../statics/menu_setting.png');\n}\n\n.setting_img:hover {\n    background-image: url('../../../../statics/menu_setting_active.png');\n}\n\n@keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n}\n\n.fade_in {\n    animation-name: fadeIn;\n    /* 动画持续时间为0.5秒 */\n    animation-duration: 0.5s;\n    /* 动画完成后保持最终状态 */\n    animation-fill-mode: forwards;\n}\n\n.back_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    background-color: #f2f2f2;\n    border: 1px solid #CBD1D8;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.back_img {\n    width: 16px;\n    height: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__-sKqk`,
	"left": `Header_left__BE6sc`,
	"right": `Header_right__FX3Fx`,
	"search_box": `Header_search_box__tumD9`,
	"search": `Header_search__DioNw`,
	"search_icon": `Header_search_icon__VLuIX`,
	"search_box_mask": `Header_search_box_mask__DQlyD`,
	"img_box": `Header_img_box__R7koX`,
	"img": `Header_img__i4fim`,
	"feedback_img": `Header_feedback_img__y6ZQd`,
	"collect_img": `Header_collect_img__USR+2`,
	"setting_img": `Header_setting_img__Gikae`,
	"fade_in": `Header_fade_in__x23EN`,
	"fadeIn": `Header_fadeIn__A9dyx`,
	"back_img_box": `Header_back_img_box__TQoio`,
	"back_img": `Header_back_img__QD0j4`
};
export default ___CSS_LOADER_EXPORT___;
